import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";

class MapSideBarForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
                    defaultMap: '1'
                },
                validated: true
            })
        }
    }

    @autobind
    handleSelect(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                defaultMap: {
                    $set: item.value
                },
            }
        }))
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin18">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        기본 지도를
                        <TSelectForm className="opt_set opt_plugin1" items={[
                            { label:'국내', value:'1' },
                            { label:'해외', value:'2' },
                        ]} selected={data.setting.defaultMap} onSelect={this.handleSelect}/>
                        로 표시합니다.
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

MapSideBarForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default MapSideBarForm
